import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import IntegrationConfigWrapper from '@/components/organisms/Integrations/Components/Integration';
import { SessionTimeoutCard } from '@/components/organisms/Integrations/Components/SessionTimeoutCard';
import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { getPermissions } from '@/redux/permissions/selectors';
import { CustomIntegration } from '@/shared/types/integration';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import { ApiSection } from './components/ApiSection';
import { CustomConfiguration } from './components/CustomConfiguration';

const IntegrationCustom = () => {
  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'integrations', actions.WRITE)
  );
  const deskId = useDeskId();
  const { integrationId } = useParams();
  const { integration } = useIntegrations<CustomIntegration>(deskId, integrationId);

  if (!integration) {
    return null;
  }

  return (
    <IntegrationConfigWrapper integration={integration}>
      <ApiSection integration={integration} canWrite={canWrite} />
      <CustomConfiguration
        key={`${integration?.config?.webhook_url}-${integration?.config?.webhook_secret}`}
        integration={integration}
        canWrite={canWrite}
      />
      <SessionTimeoutCard integration={integration} canWrite={canWrite} />
    </IntegrationConfigWrapper>
  );
};

export default IntegrationCustom;
